import featureNames from 'constants/feature_names';

angular.module('gym.contacts').controller('ShowFlagsCtrl', ["$scope", "$window", "$modalInstance", "ContactFlagsService", "EmploymentService", "contact", function($scope, $window, $modalInstance, ContactFlagsService, EmploymentService, contact) {
  var getFlags;
  $scope.permissions = EmploymentService.get().permissions;
  $scope.featureNames = featureNames;
  getFlags = function() {
    $scope.isLoading = true;
    return contact.all('flags').getList().then(function(data) {
      $scope.isLoading = false;
      return $scope.flags = data;
    });
  };
  getFlags();
  $scope.getTags = function(flag) {
    return flag.tag_list.join(', ');
  };
  // $modalInstance.close($scope.params)
  $scope.edit = function(flag) {
    $modalInstance.dismiss('cancel');
    return ContactFlagsService.editFlag(contact, flag.id).then(function() {
      return ContactFlagsService.showFlags(contact);
    }, function() {
      return ContactFlagsService.showFlags(contact);
    });
  };
  $scope.dismiss = function(flag, index) {
    var message;
    message = "Are you sure?";
    if ($window.confirm(message)) {
      return flag.all('dismiss_from_contact_profile').remove().then(function() {
        return $scope.flags.splice(index, 1);
      });
    }
  };
  return $scope.cancel = function() {
    return $modalInstance.dismiss('cancel');
  };
}]);
